import"./descendant/useDescendant.js";import{createContext as t}from"../../utils/react/context.js";const[e,n]=t({strict:!1,name:"MenuContext"});export{e as MenuProvider,n as useMenuContext};
//# sourceMappingURL=useMenuContext.js.map
